import React from "react";

function SvgComponent() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <mask
        id="mask0_1414_13268"
        style={{ maskType: "luminance" }}
        width="20"
        height="20"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#fff" d="M0 0h20v20H0V0z"></path>
      </mask>
      <g fill="currentColor" mask="url(#mask0_1414_13268)">
        <path d="M19.167 15.833a3.334 3.334 0 01-3.334 3.334h-1.666V17.5h1.666a1.666 1.666 0 100-3.333h-1.666V12.5h1.666a3.334 3.334 0 013.334 3.333zm-11.667 0a3.333 3.333 0 013.333-3.333H12.5v1.667h-1.667a1.667 1.667 0 000 3.333H12.5v1.667h-1.667A3.333 3.333 0 017.5 15.833z"></path>
        <path d="M11.667 15H15v1.667h-3.333V15zM7.5 4.167a2.5 2.5 0 102.5 2.5 2.508 2.508 0 00-2.5-2.5zm0 3.333a.833.833 0 110-1.666.833.833 0 010 1.666zm-3.075 5a5.843 5.843 0 013.075-.933c.217.002.433.02.648.053a4.97 4.97 0 012.685-.786h.212A7.832 7.832 0 007.5 9.909c-1.692 0-5 .891-5 2.983v1.275h3.624a4.99 4.99 0 01.99-1.667H4.425z"></path>
        <path d="M13.333 1.667H9.85a2.49 2.49 0 00-4.7 0H1.667A1.672 1.672 0 000 3.333V15a1.672 1.672 0 001.667 1.667H5.95a3.005 3.005 0 010-1.667H1.667V3.334h11.666v7.5H15v-7.5a1.671 1.671 0 00-1.667-1.667zM7.5 2.708a.63.63 0 01-.625-.625.625.625 0 11.625.625z"></path>
      </g>
    </svg>
  );
}

export default SvgComponent;
